import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter className="footer-dark app-shell-footer">
     
    </CFooter>
  )
}

export default React.memo(AppFooter)
